import { render, staticRenderFns } from "./rpt2402.vue?vue&type=template&id=283621a4&"
import script from "./rpt2402.vue?vue&type=script&lang=js&"
export * from "./rpt2402.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports